module.exports = __webpack_public_path__ + "img/hr-branch-particle-05.bb7d37ba.png";